<app-product-property-text-list-editor
	[listValues$]="listValues$"
	(doneEditing)="doneEditingHandler()"
	[addItemRegex]="this.paramsCustom.addItemRegex"
	[addItemRegexError]="this.paramsCustom.addItemRegexError"
>
</app-product-property-text-list-editor>
